import { useState } from 'react';

export default function HeroSection() {
  const [formData, setFormData] = useState({
    matricula: '',
    marca: '',
    telefono: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const message = `Hola Desguaces Barcelona,%0A%0AQuiero valorar mi coche:%0A%0A📋 *Matrícula:* ${formData.matricula}%0A🚙 *Marca y Modelo:* ${formData.marca}%0A📞 *Teléfono:* ${formData.telefono}%0A%0AProcedo de: www.desguacesbarcelona.com`;
      
      window.open(`https://wa.me/34932932913?text=${message}`, '_blank');
      
      setSubmitStatus('success');
      setFormData({ matricula: '', marca: '', telefono: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a8108483134f84c8bcc385dee9c192d0.jpg"
          alt="Desguace profesional en Barcelona"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7 text-white">
              <div className="inline-flex items-center bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/30">
                <i className="ri-award-line text-[#ff6b35] mr-2"></i>
                <span className="text-sm font-medium">Líderes en Barcelona desde 2010</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-black mb-6 leading-tight">
                Desguace en Barcelona<br />
                <span className="text-[#ff6b35]">Vende tu Coche</span><br />
                Al Mejor Precio
              </h1>

              <p className="text-xl lg:text-2xl font-medium mb-8 text-white/90">
                Siniestrado • Averiado • Sin ITV • Cualquier Estado
              </p>

              <div className="flex flex-wrap gap-4 mb-8">
                <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg border border-white/20">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#ff6b35] rounded-full mr-3">
                    <i className="ri-time-line text-white text-lg"></i>
                  </div>
                  <span className="font-semibold text-sm">Tasación en 24h</span>
                </div>
                <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg border border-white/20">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#ff6b35] rounded-full mr-3">
                    <i className="ri-truck-line text-white text-lg"></i>
                  </div>
                  <span className="font-semibold text-sm">Recogida Gratis</span>
                </div>
                <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg border border-white/20">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#ff6b35] rounded-full mr-3">
                    <i className="ri-money-euro-circle-line text-white text-lg"></i>
                  </div>
                  <span className="font-semibold text-sm">Pago Inmediato</span>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <a 
                  href="tel:+34932932913" 
                  className="bg-[#ff6b35] text-white px-8 py-4 rounded-full text-base font-bold hover:bg-[#e55a2b] transition-all shadow-2xl hover:shadow-[#ff6b35]/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Llamar 932 932 913
                </a>
                <a 
                  href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20tasar%20mi%20coche%20gratis" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-bold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer inline-flex items-center"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-[#1a2332] rounded-2xl p-8 shadow-2xl">
                <h2 className="text-2xl font-bold text-white mb-2">Tasación Gratuita</h2>
                <p className="text-white/70 text-sm mb-6">Respuesta en menos de 5 minutos</p>

                <form id="tasacion-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="matricula" className="block text-white text-sm font-medium mb-2">
                      Matrícula del vehículo
                    </label>
                    <input
                      type="text"
                      id="matricula"
                      name="matricula"
                      value={formData.matricula}
                      onChange={(e) => setFormData({...formData, matricula: e.target.value})}
                      placeholder="Ej: 1234ABC"
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#ff6b35]"
                    />
                  </div>

                  <div>
                    <label htmlFor="marca" className="block text-white text-sm font-medium mb-2">
                      Marca y Modelo
                    </label>
                    <input
                      type="text"
                      id="marca"
                      name="marca"
                      value={formData.marca}
                      onChange={(e) => setFormData({...formData, marca: e.target.value})}
                      placeholder="Ej: Seat Ibiza"
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#ff6b35]"
                    />
                  </div>

                  <div>
                    <label htmlFor="telefono" className="block text-white text-sm font-medium mb-2">
                      Teléfono de contacto
                    </label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                      placeholder="+34 XXX XXX XXX"
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#ff6b35]"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#ff6b35] text-white py-4 rounded-full font-bold text-base hover:bg-[#e55a2b] transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer flex items-center justify-center"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Enviando...
                      </>
                    ) : (
                      <>
                        <i className="ri-whatsapp-line mr-2"></i>
                        Enviar por WhatsApp
                      </>
                    )}
                  </button>

                  {submitStatus === 'success' && (
                    <div className="bg-green-500/20 border border-green-500 text-white px-4 py-3 rounded-lg text-sm">
                      ¡Redirigiendo a WhatsApp! Te contactaremos pronto.
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="bg-red-500/20 border border-red-500 text-white px-4 py-3 rounded-lg text-sm">
                      Error al enviar. Por favor, inténtalo de nuevo.
                    </div>
                  )}

                  <p className="text-white/50 text-xs text-center">
                    Al enviar aceptas nuestra política de privacidad
                  </p>
                </form>

                <div className="mt-6 pt-6 border-t border-white/10 text-center">
                  <p className="text-white/70 text-sm mb-2">
                    <i className="ri-shield-check-line text-[#ff6b35] mr-1"></i>
                    Más de 15.000 coches comprados
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
